// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","highlights":"_1FV_YGPmNIz9eSUYZ-nWOJ","highlightItems":"_E-RrjXV1ZrTa5qbkOlXd","highlightCategory":"_3MXxmBzRvalRVgrlrvShzZ"};